import { PamtokenService } from "./core/services/pamtoken.service";
import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import {
  EmailVerifyComponent,
  SupportPageComponent,
  TermsAndConditionsComponent,
  EnrollComponent,
  BlockedComponent,
  RedeemPointsComponent,
  OpenHouseQuizComponent,
} from "./shared";
import { MaintenanceComponent } from "./shared/components/maintenance/maintenance.component";
import { AuthGuard, MaintainanceGaurd, CanAccessHomeModule } from "./core";
import { QuizComponent } from "./shared/components/quiz/quiz.component";
import { WelcomepageComponent } from "./home/welcomepage/welcomepage.component";
import { UserAccessValidationComponent } from "./shared/components/user-access-validation/user-access-validation/user-access-validation.component";
import { ApproverComponent } from "./home/approver/approver.component";
import { CallbackComponent } from "./core/auth/callback.component";
import { HomeComponent } from "./home/home.component";
import { ProfileComponent } from "./profile/profile.component";
import { LeaderboardComponent } from "./home/leaderboard/leaderboard.component";
import { ManageClaimsComponent } from "./home/manage-claims/manage-claims.component";
import { ManageActivitiesComponent } from "./home/manage-activities/manage-activities.component";
import { PrescribedEnablementsComponent } from "./home/prescribed-enablements/prescribed-enablements.component";
import { RewardsComponent } from "./home/rewards/rewards.component";
import { AccountDetailsComponent } from "./home/account-details/account-details.component";
import { AdminManageClaimsComponent } from "./home/admin-manage-claims/admin-manage-claims.component";
import { CreatePromoSavedGuard } from "./core/services/create-promo-saved.guard";
import { QuizChallengeComponent } from "./home/manage-activities/quiz-challenge/quiz-challenge.component";
import { DashboardComponent } from "./home/dashboard/dashboard.component";
import { BasicInfoComponent } from "./profile/basic-info/basic-info.component";
import { TaxInfoComponent } from "./profile/tax-info/tax-info.component";
import { TaxInfoW9Component } from "./profile/tax-info-w9/tax-info-w9.component";

const routes: Routes = [
  {
    path: 'login',
    loadChildren: './login/login.module#LoginModule',
    canActivate: [MaintainanceGaurd]
  },
  {
    path: "callback",
    component: CallbackComponent,
  },
  {
    path: "enroll",
    component: EnrollComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "blocked",
    component: BlockedComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "redeem-points",
    component: RedeemPointsComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "email/:type/:token",
    component: EmailVerifyComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "role/:type/:token",
    component: EmailVerifyComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "sca/:status/:verification-token",
    component: EmailVerifyComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "emails/unsubscribe/:notificationTypeId",
    component: EmailVerifyComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "support",
    component: HomeComponent,
    canActivate: [MaintainanceGaurd],
    children: [
      { path: '', component: SupportPageComponent }
    ]
  },
  {
    path: "open-house-quiz",
    component: OpenHouseQuizComponent,
    canActivate: [MaintainanceGaurd],
  },

  {
    path: "seller-rewards-quiz/:id",
    component: QuizComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "seller-rewards-quiz",
    component: QuizComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "maintenance",
    component: MaintenanceComponent,
  },
  {
    path: "termsandconditions",
    component: TermsAndConditionsComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "profile",
    component: ProfileComponent,
    canActivate: [MaintainanceGaurd, AuthGuard],
    children: [
      { path: '', component: BasicInfoComponent },
      { path: 'tax-infot4', component: TaxInfoComponent },
      { path: 'tax-infow9', component: TaxInfoW9Component }
    ]
  },
  {
    path: "home",
    component: HomeComponent,
    canActivate: [MaintainanceGaurd, AuthGuard, CanAccessHomeModule],
    children: [
      { path: 'manager/leaderboards', component: LeaderboardComponent },
      { path: 'manager/manage-challenges', component: ManageActivitiesComponent, canDeactivate: [CreatePromoSavedGuard] },
      { path: 'manager/admin-manage-claims', component: AdminManageClaimsComponent },
      { path: 'manager/account-details', component: AccountDetailsComponent },
      { path: 'seller/leaderboards', component: LeaderboardComponent },
      { path: 'seller/manage-claims', component: ManageClaimsComponent },
      { path: 'seller/challenges', component: PrescribedEnablementsComponent },
      { path: 'seller/redeem-rewards', component: RewardsComponent },
      { path: 'manager/quizChallenge', component: QuizChallengeComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'manageCashPayment', loadChildren: './home/managecashpayment/managecashpayment.module#ManagecashpaymentModule' }
    ]
  },
  {
    path: "welcome",
    component: WelcomepageComponent,
    canActivate: [MaintainanceGaurd, AuthGuard],
  },
  {
    path: "user-access-validation",
    component: UserAccessValidationComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "approver",
    component: ApproverComponent,
    canActivate: [MaintainanceGaurd],
  },
  {
    path: "showcase",
    loadChildren: "./shared/ui/showcase/showcase.module#ShowcaseModule"
  },

  {
    path: "**",
    redirectTo: "/",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
  providers: [AuthGuard, MaintainanceGaurd, CanAccessHomeModule],
})
export class AppRoutingModule {}
